import { useLocation } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import { URLPaths } from 'models/enums';
import PageLayout from 'domains/core/components/PageLayout';
import useBrandProfile from 'hooks/queries/useBrandProfile';
import BrandSetupEmptyStatePage from './BrandSetupEmptyStatePage';
import BrandSetupLandingPage from './BrandSetupLandingPage';
import BrandSetupEditPage from './BrandSetupEditPage';

/**
 * Renders Brand Setup empty/landing when on /settings/brand;
 * renders edit form when on /settings/brand/edit.
 */
const SettingsBrandRoute = () => {
    const location = useLocation();
    const isEditPath = location.pathname === URLPaths.SETTINGS_BRAND_EDIT;

    if (isEditPath) {
        return <BrandSetupEditPage />;
    }
    return <BrandSetupRouter />;
};

/**
 * Renders empty state or landing based on brand profile data.
 */
const BrandSetupRouter = () => {
    const { data: brandProfile, isLoading, isError } = useBrandProfile();

    if (isLoading) {
        return (
            <Stack data-testid="brand-setup-loading" role="main">
                <PageLayout showSettingsHeader header="brand setup">
                    <Stack p={4} alignItems="center">
                        <Typography variant="body1">Loading...</Typography>
                    </Stack>
                </PageLayout>
            </Stack>
        );
    }
    if (isError) {
        return <BrandSetupEmptyStatePage />;
    }

    const hasAnyValues = brandProfile?.some((field) => {
        const v = field.currentValue;
        if (v === null || v === undefined) return false;
        if (v === '') return false;
        if (Array.isArray(v) && v.length === 0) return false;
        return true;
    });

    if (!hasAnyValues) {
        return <BrandSetupEmptyStatePage />;
    }

    return <BrandSetupLandingPage brandProfile={brandProfile ?? []} />;
};

export default SettingsBrandRoute;
